import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { clienteService, Cliente } from '../../services/clienteService';
import ClienteForm from '../Clientes/ClienteForm';

interface ClienteSelectorProps {
  onSelect: (cliente: Cliente) => void;
  onClose: () => void;
}

const ClienteSelector = ({ onSelect, onClose }: ClienteSelectorProps) => {
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery(
    ['clientes-buscar', search],
    () => clienteService.buscar(search),
    {
      enabled: search.length >= 2,
      staleTime: 30000
    }
  );

  const handleSelect = (cliente: Cliente) => {
    onSelect(cliente);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Seleccionar Cliente</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        <div className="mb-4 flex space-x-2">
          <input
            type="text"
            placeholder="Buscar por nombre, email o teléfono..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="flex-1 px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          <button
            onClick={() => setShowForm(true)}
            className="px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700"
          >
            + Nuevo
          </button>
        </div>

        <div className="space-y-2 max-h-96 overflow-y-auto">
          {isLoading && search.length >= 2 && (
            <div className="text-center py-4 text-gray-500">Buscando...</div>
          )}

          {search.length < 2 && (
            <div className="text-center py-4 text-gray-500">
              Escribe al menos 2 caracteres para buscar
            </div>
          )}

          {data?.data.clientes && data.data.clientes.length === 0 && search.length >= 2 && (
            <div className="text-center py-4 text-gray-500">
              No se encontraron clientes
            </div>
          )}

          {data?.data.clientes?.map((cliente) => (
            <button
              key={cliente.id}
              onClick={() => handleSelect(cliente)}
              className="w-full text-left p-4 border rounded hover:bg-gray-50 transition"
            >
              <div className="font-medium">{cliente.nombre}</div>
              {cliente.email && (
                <div className="text-sm text-gray-500">{cliente.email}</div>
              )}
              {cliente.telefono && (
                <div className="text-sm text-gray-500">{cliente.telefono}</div>
              )}
            </button>
          ))}
        </div>
      </div>

      {showForm && (
        <ClienteForm
          onClose={() => {
            setShowForm(false);
            queryClient.invalidateQueries(['clientes-buscar']);
          }}
          onSuccess={(nuevoCliente) => {
            // Seleccionar automáticamente el cliente recién creado
            handleSelect(nuevoCliente);
          }}
        />
      )}
    </div>
  );
};

export default ClienteSelector;

